import React, { useEffect } from "react";
import firebaseManager from "../../model/Firebase/FirebaseManager";

const Dent = () => {
  const getDent = () => {
    firebaseManager.dentSelect();
  };

  useEffect(() => {
    getDent();
  }, []);

  return <div className="text-center" id="dentSelect"></div>;
};

export default Dent;
